import { Message } from '@alifd/next';
import axios from 'axios';
import { history } from 'ice';

import commonhelper from '@/lib/commonhelper';

import client from '../../../../lib/feathers';

const usersService = client.service('users');

export const jumpPage = () => {
  if (
    history.location.pathname === '/mobile/user/person' ||
    history.location.pathname.includes('/mobile')
  ) {
    history.push('/mobile/setting');
    commonhelper.pageReload();
  } else {
    history.push('/ezpro/home');
    commonhelper.pageReload();
  }
};

export const resetPassword = async (password) => {
  try {
    await axios('/ezcon/api/resetPassword', {
      method: 'POST',
      headers: { authorization: window.localStorage['feathers-jwt'] },
      data: { password },
    });
  } catch (error) {
    console.error('Error', error);
    Message.error('密碼重設失敗');
  }
};

export const updateFile = async (file) => {
  const formData = new FormData();
  formData.append('files', file);

  try {
    await axios('/uploads?type=userPerson', {
      method: 'POST',
      headers: { authorization: window.localStorage['feathers-jwt'] },
      data: formData,
    });
  } catch (error) {
    console.error('Error', error);
    Message.error('檔案更新失敗');
  }
};

export const findSameHouseholdUsers = async (householdNumbers) => {
  try {
    const { data } = await usersService.find({
      query: {
        householdNumbers: { $in: householdNumbers },
      },
    });
    return data;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

export const checkNickNameAndResidentNameIsSame = ({
  users,
  newNickName,
  dataEmail,
}) => {
  const otherSameHouseholdUsers = users.filter(
    (user) => user.email !== dataEmail
  );
  const userNameList = otherSameHouseholdUsers.map((userInfo) => userInfo.name);
  const isNickNameAndResidentNameSame = userNameList.includes(newNickName);
  return isNickNameAndResidentNameSame;
};

export const updateUserInfo = async ({ currentAuthId, name, email }) => {
  try {
    await usersService.patch(currentAuthId, {
      name,
      email,
    });
  } catch (error) {
    console.log('==users update name fail:', error);
    Message.error(`${error}`);
  }
};

export const handleSubmitErrors = ({ values, errors, currentNameStatus }) => {
  let hasErrors = false;

  if (errors) {
    console.log('errors', errors);
    hasErrors = true;
  }

  if (!values.email) {
    Message.error('帳號不得為空');
    hasErrors = true;
  }

  const isNickNameIncludeSpace = values.name.indexOf(' ') >= 0;
  if (currentNameStatus && isNickNameIncludeSpace) {
    Message.error('暱稱不得為空');
    hasErrors = true;
  }

  const isPasswordReset = values.password || values.rePassword;
  const isPasswordNotSame = values.password !== values.rePassword;
  if (isPasswordReset && isPasswordNotSame) {
    Message.error('請檢查新密碼是否輸入正確');
    hasErrors = true;
  }

  return hasErrors;
};
